<template>
    <section :class="['container d-flex align-items-center justify-content-center', paddingClasses]">
        <div :class="['loader', paddingClasses]">
            <div class="loader__item"></div>
            <div class="loader__item"></div>
            <div class="loader__item"></div>
        </div>
    </section>
</template>

<script>
export default {
  name: "ViewLoader",
  props: {
    paddingClasses: {
      type: String,
      required: false,
      default: 'py-5 py-lg-10'
    },

  }
}
</script>
